import './react';
import './react-router';
import './react-dom';
import './mobx-react';
import './react-redux';
import './styled-components';
import '~/common/components/AsyncComponent';

evite.resolve('react');
